export const CLOTHING_DISPOSITION = {
  path: '/common/clothing/dispositions', units: '/units/', actions: '/actions',
  returnPath: '/return', retentionPath: '/retention',
  agree: 'AGREE', externalAgree: 'EXTERNAL_AGREE', requote: 'REQUOTE',
  deduction: 'CONFIRM_DEDUCTION', exception: 'REPORT_EXCEPTION', returnAction: 'RETURN',
  correct: 'CORRECT_DATE', cancel: 'CANCEL_DEDUCTION', retain: 'RETAIN',
  reconcileException: 'RECONCILE_EXCEPTION', reapply: 'REAPPLY_DEDUCTION',
  resume: 'RESUME', resumePath: '/resume',
  quoted: 'QUOTED', awaiting: 'AWAITING_DEDUCTION', retained: 'RETAINED', returned: 'RETURNED',
  missingEvidenceKey: 'CLOTHING_DISPOSITION_EVIDENCE_REQUIRED'
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/employee-assets/clothing-disposition.constants.ts